<template>
  <div>
    <div class="clearfix margin-top-20"
         v-if="type=='add'">
      <Form :label-width="120">
        <Col span="12">
        <FormItem label="订单投保">
          <div v-if="type=='query' || noOrderSource">{{formData.deliverOrderNo}}</div>
          <Input v-else
                 v-model="formData.deliverOrderNo"
                 style="width:80%;float:left">
          <Button slot="append"
                  icon="ios-search"
                  @click.native="handleOrderList"></Button>
          </Input>
          <Checkbox class="margin-left-20"
                    v-model="noOrderSource"
                    @on-change="clearformData"
                    :disabled="type!='add'">{{$t('erp.aftersales.noorder',{defaultValue:'无订单'})}}</Checkbox>
        </FormItem>
        </Col>
      </Form>
    </div>

    <!-- 投保信息 -->
    <compWrapper title="投保信息"
                 theme="primary">
      <compFormQuery v-if="type=='query'"
                     class="margin-top-15 margin-right-15"
                     :formdata="getBase"
                     :value="formData"
                     :labelWidth="120" />
      <compFormEdit v-else
                    class="margin-top-15 margin-right-15"
                    ref="editform1"
                    :formdata="getBase"
                    v-model="formData"
                    :labelWidth="120" />
    </compWrapper>
    <!-- 投保物流信息 -->
    <compWrapper title="投保物流信息"
                 theme="primary">
      <compFormQuery v-if="type=='query'"
                     class="margin-top-15 margin-right-15"
                     :formdata="getWarehouse"
                     :value="formData"
                     :labelWidth="120" />
      <compFormEdit v-else
                    class="margin-top-15 margin-right-15"
                    ref="editform2"
                    :formdata="getWarehouse"
                    v-model="formData"
                    :labelWidth="120" />
    </compWrapper>
    <!-- 投保商品信息 -->
    <compWrapper title="投保商品信息"
                 theme="primary">
      <Form :label-width="120"
            class="margin-top-15"
            v-if="noOrderSource && type!='query'">
        <Row>
          <Col span="12">
          <FormItem label="ERPSKU">
            <Select clearable
                    filterable
                    v-model="erpSku"
                    ref="zierpselect"
                    remote
                    :remote-method="remoteMethod1"
                    :loading="loading1">
              <Option v-for="json in erpSkusList"
                      :value="json.erpSku"
                      :key="json.id">{{ json.erpSku }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem :label="$t('fbb.accountmanage.amount',{defaultValue:'数量'})">
            <Input v-model="number"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem :label="$t('global.common.notes',{defaultValue:'备注'})">
            <Input type="textarea"
                   v-model="formData.remark"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <Button style="margin-left:120px"
                  type="primary"
                  @click="addErpsku(erpSku,number)">添加</Button>
          </Col>
        </Row>
      </Form>
      <Table style="margin:15px"
             :columns="columns"
             :data="datalist"
             size="small"
             ref="table"
             border
             stripe>
      </Table>

    </compWrapper>
    <!-- 保费信息 -->
    <compWrapper title="保费信息"
                 theme="primary">
      <compFormQuery v-if="type=='query'"
                     class="margin-top-15 margin-right-15"
                     :formdata="getCost"
                     :value="formData"
                     :labelWidth="120" />
      <compFormEdit v-else
                    class="margin-top-15 margin-right-15"
                    ref="editform3"
                    :formdata="getCost"
                    v-model="formData"
                    :labelWidth="120" />
    </compWrapper>

    <compLog v-if="type==='query'"
             wrapper
             :data="logList"></compLog>
    <div class="text-right"
         v-if="type!='query'">
      <Button v-if="formData.insuranceStatus !=1 "
              type="primary"
              @click="submit('edit')">保存为草稿</Button>
      <Button type="info"
              class="margin-left-10"
              @click="submit('confirm')">保存并提交</Button>
      <Button class="margin-left-10"
              @click="cancel">取消</Button>
    </div>
  </div>
</template>

<script>
import {
  HttpGetDeliverOrderOne,
  HttpTransType,
  HttpGetProductOne,
  HttpSaveInsuranceOrder,
  HttpGetInsuranceOrderOne,
  HttpSubmitInsuranceOrder,
  HttpVsSkuList,
} from "@/service/credit";
import { HttpNextOrgSelfList } from '@mods/service/dictionary';
import { HttpInboundOrderLogList } from "@/service/inbound";
import { mapGetters } from 'vuex';

export default {
  props: ['querytype', 'activeid'],
  data () {
    return {
      type: this.querytype || this.$route.params.type,
      id: this.activeid || this.$route.query.id,
      datalist: [],
      showSource: false,
      formData: {
        totalAmount: 0,
        insuranceProportion: 100,
        transportationData: '',
        platformNo: '',
        insuranceServiceId: '',

      },
      loading1: false,
      number: 0,
      remark: '',
      erpSku: '',
      noOrderSource: false,
      erpSkusList: [],
      logList: [],
      transportList: [
        { value: 0, label: '快递' },
        { value: 1, label: '卡车' },
      ],
      insuranceFeeCurrency: '',
    //   hostOrgId: '',
    }
  },
  created () {
    // HttpNextOrgSelfList().then(res => {
    //     this.hostOrgId = res.data.filter(item=>item.id == global.SYSID)[0].hostId || global.SYSID
    // }, err => {
    //     this.$VMessage.error(err.message);
    // })
    if (this.type == 'add') return;
    this.getDetail();
    if (this.type == 'query') {
      // 请求日志的接口
      HttpInboundOrderLogList({ 'search[EQ_orderType]': 9001, 'search[EQ_orderId]': this.id }).then(res => {
        this.logList = res.data;
      }).catch(err => {
        this.loading = false;
        this.$Message.error(err.message);
      })
    }
  },
  computed: {
    ...mapGetters('dictionary', ['getOrgList', 'getInsuranceList', 'getCountryList', 'getFBBFilterDisabledAllWarehouse',]),
    ...mapGetters("common", ["getStateList"]),
    insuranceList () {
      return this.getInsuranceList.filter(item => {
        return item.attach.status === 0
      })
    },
    getBase () {
      return [
        {
          label: '客户单号',
          key: "sourceNo",
          tag: "vInput",
          required: false,
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
          show: !this.noOrderSource
        },
        {
          label: '平台订单号',
          key: "platformNo",
          tag: "vInput",
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          }
        },
        {
          label: '保险产品',
          key: "insuranceServiceId",
          tag: "vSelect",
          options: this.insuranceList,
          props: {
            filterable: true,
            placeholder: '请选择',
          },
          on: {
            'on-change': (val) => {
              if (!this.noOrderSource) {
                this.getTransType(val)
              }
            }
          }
        },
        {
          label: '保单号',
          key: "policyNumber",
          tag: "vInput",
          show: this.type == 'query',
          render: () => {
            return <div><a onClick={this.clickUrl}>{this.formData.policyNumber}</a></div>
          }
        },
        {
          label: '投保完成时间',
          key: "insuranceCompletionTime",
          tag: "vInput",
          show: this.type == 'query'
        },


      ]
    },
    getWarehouse () {
      return [
        {
          label: '快递公司',
          key: "carrierCode",
          tag: "vSelect",
          options: [
            { value: 'FedEx', label: 'FedEx' },
            { value: 'UPS', label: 'UPS' },
            { value: 'LTL', label: 'LTL' },
          ],
          props: {
            placeholder: '请选择',
            filterable: true,
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
          on: {
            'on-change': (val) => {
              if (val == 'LTL') {
                // this.formData.transportationType = 1;
                this.transportList = [
                  { value: 1, label: '卡车' },
                ];
                this.$set(this.formData, 'transportationType', 1);
              }
              if (val == 'FedEx' || val == 'UPS') {
                // this.formData.transportationT = 0;
                this.transportList = [
                  { value: 0, label: '快递' },
                ];
                this.$set(this.formData, 'transportationType', 0);
              }
            }
          }
        },
        {
          label: '运输方式',
          key: "transportationType",
          tag: "vSelect",
          options: this.transportList,
          props: {
            placeholder: '请选择',
            filterable: true,
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          }
        },

        {
          label: '起运仓库',
          tag: 'vSelect',
          key: 'orgWarehouseId',
          options: this.getFBBFilterDisabledAllWarehouse,
          props: {
            placeholder: '请选择',
            filterable: true,
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
        },
        {
          tag: 'div',
          span: 24,
          formItem: {
            style: "margin-bottom:0;min-height:0 !important;"
          }
        },
        {
          label: '起运地地址',
          tag: 'vInput',
          key: 'shipFromAdress',
          show: this.formData.orgWarehouseId == 0,
        },
        {
          label: '起运地国家',
          tag: 'vSelect',
          key: 'shipFromCountry',
          options: this.getCountryList,
          props: {
            placeholder: '请选择',
            filterable: true,
          },
          show: this.formData.orgWarehouseId == 0,
          on: {
            'on-change': () => {
              this.formData.shipFromState = ''
            }
          }
        },
        {
          label: '起运地城市',
          tag: 'vInput',
          key: 'shipFromCity',
          show: this.formData.orgWarehouseId == 0,
        },

        {
          label: '起运地州/省份',
          tag: 'vSelect',
          key: 'shipFromState',
          options: this.getStateList.map(item => {
            return {
              value: item,
              label: item
            }
          }),
          props: {
            placeholder: '请选择',
            filterable: true
          },
          show: this.formData.orgWarehouseId == 0 && this.formData.shipFromCountry == 'US',
        },
        {
          label: '起运地州/省份',
          tag: 'vInput',
          key: 'shipFromState',
          show: this.formData.orgWarehouseId == 0 && this.formData.shipFromCountry != 'US',
        },
        {
          label: '起运地邮编',
          tag: 'vInput',
          key: 'shipFromPostal',
          show: this.formData.orgWarehouseId == 0,
        },
        {
          label: '目的地',
          tag: 'vInput',
          key: 'shipToAdress',
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          }
        },
        {
          label: '目的地国家',
          tag: 'vSelect',
          key: 'shipToCountry',
          options: this.getCountryList,
          props: {
            placeholder: '请选择',
            filterable: true,
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
          on: {
            'on-change': () => {
              this.formData.shipToState = ''
            }
          }
        },
        {
          label: '目的地城市',
          tag: 'vInput',
          key: 'shipToCity',
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          }
        },

        {
          label: '目的地州/省份',
          tag: 'vSelect',
          key: 'shipToState',
          options: this.getStateList.map(item => {
            return {
              value: item,
              label: item
            }
          }),
          props: {
            placeholder: '请选择',
            filterable: true,
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
          show: this.formData.shipToCountry == 'US'
        },
        {
          label: '目的地州/省份',
          tag: 'vInput',
          key: 'shipToState',
          show: this.formData.shipToCountry != 'US',
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
        },
        {
          label: '目的地邮编',
          tag: 'vInput',
          key: 'shipToPostal',
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          }
        },
        {
          label: '起运日期',
          key: 'transportationData',
          tag: "vDatepicker",
          props: {
            format: 'yyyy-mm-dd',
            confirm: false,
            // readonly: !this.noOrderSource,
            // disabled: !this.noOrderSource,
          },
        },
      ]
    },
    getCost () {
      return [
        {
          label: '投保类型',
          key: 'insuranceType',
          tag: "vSelect",
          options: [
            { value: 1, label: '采购价格' },
            { value: 0, label: '销售价格' },
          ],
        },
        {
          label: '总货值 USD',
          tag: 'vInput',
          key: 'totalAmount',
          props: {
            readonly: !this.noOrderSource,
            disabled: !this.noOrderSource,
          },
          on: {
            'on-change': () => {
              this.changeAmount()
            }
          }
        },
        {
          label: '加成比例',
          tag: 'vInputNumber',
          key: 'insuranceProportion',
          props: {
            style: 'width:100%',
          },
          on: {
            'on-change': () => {
              this.changeAmount()
            }
          },
          formItem: {
            tip: this.type != 'query' ? "<div class=color-error>加成比例填写请在100-130之间</div>" : '',
          }
        },
        {
          label: '投保金额 USD',
          tag: 'vInput',
          key: 'insuranceAmount',
          required: false,
          props: {
            readonly: true,
            disabled: true,
          }
        },
        // {
        //     label: '保费 ' + this.insuranceFeeCurrency,
        //     tag: 'vInput',
        //     key: 'insuranceFee',
        //     required: false,
        //     props:{
        //         readonly:!this.noOrderSource,
        //         disabled:!this.noOrderSource,
        //     },
        //     show:this.type == 'query'
        // },
      ]
    },
    columns () {
      let data = [
        {
          key: 'trackingNo',
          title: 'Tracking',
          render: (h, { row, index }) => {
            if (this.formData.transportationType == 0 && this.type != 'query') {
              return h('Input', {
                props: {
                  size: 'small',
                  value: row.trackingNo
                },
                on: {
                  'input': (event) => {
                    row.trackingNo = event
                    this.datalist[index] = row
                  }
                },
              })
            } else {
              return <div>{row.trackingNo}</div>
            }
          }
        },
        {
          title: 'ERPSKU',
          key: 'erpsku',
        },
        {
          title: this.$t('erp.product.category_name', { defaultValue: '品名' }),
          key: 'name',
        },
        {
          title: this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
          key: 'qty',
        },
        {
          title: '包装类型',
          key: 'packageType',
          render: (h, { row }) => {
            return <div>{row.packageType == 0 ? '纸箱' : '其他'}</div>
          }
        },
        {
          title: this.$t('global.common.weight', { defaultValue: '重量' }) + '(g)',
          key: 'weight',
        },
        {
          title: '是否易碎品',
          key: 'isFragile',
          render: (h, { row }) => {
            return <div>{row.isFragile == 0 ? '否' : '是'}</div>
          }
        },
        {
          title: this.$t('global.common.actions', { defaultValue: '操作' }),
          render: (h, { row, index }) => {
            return h('div', [
              h('Button', {
                props: {
                  theme: "error",
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.remove(index)
                  }
                },
                style: {
                  'margin-right': '15px'
                }
              }, '删除')
            ])
          }
        },
      ];
      if (this.type == 'query' || !this.noOrderSource) {
        data.splice(7, 1)
      }
      return data
    },
  },
  methods: {
    clickUrl () {
      window.open(this.formData.insuranceAttachmentUrl)
    },
    clearformData () {
      this.formData = {
        totalAmount: 0,
        insuranceProportion: 100,
        insuranceServiceId: '',
      }
      this.datalist = [];
      if (this.noOrderSource) {
        this.transportList = []
      } else {
        this.transportList = [
          { value: 0, label: '快递' },
          { value: 1, label: '卡车' },
        ];
      }
    },
    changeAmount () {
      let num = Number(this.formData.totalAmount * (this.formData.insuranceProportion / 100));
      this.$set(this.formData, 'insuranceAmount', num.toFixed(4));

    },
    addErpsku (erpSku, number) {
      if (!erpSku || number == 0) {
        this.$Message.error('请检查erpsku或者数量是否填写！'); return;
      }
      let one = this.erpSkusList.filter(item => {
        return item.erpSku == erpSku
      })[0]

      let data = {
        name: one.nameEn,
        erpsku: one.erpSku,
        weight: one.weight,
        trackingNo: '',
        productId: one.id,
        qty: number,
        packageType: one.materialType,
        isFragile: one.isFragile,
        oneAmount: Number(one.insuranceRate * number)
      }

      this.datalist.push(data);
      let amount = this.datalist.reduce((pre, cur) => {
        pre = pre + cur.oneAmount;
        return pre
      }, 0)
      this.formData.totalAmount = amount;
      let num = Number(this.formData.totalAmount * (this.formData.insuranceProportion / 100))
      this.$set(this.formData, 'insuranceAmount', num.toFixed(4));
    },
    handleOrderList () {
      HttpGetDeliverOrderOne({
        deliverOrderNo: this.formData.deliverOrderNo,
      }).then(res => {
        if (res.data.deliverOrderStatus != 1) {
          this.$Message.error({ content: '此单号不是已推送状态，请重新输入！', duration: 5 });
          return;
        }
        this.formData.sourceId = res.data.id,
          this.$set(this.formData, 'sourceNo', res.data.deliverOrderNo);
        this.$set(this.formData, 'platformNo', res.data.sourceNo);
        this.$set(this.formData, 'carrier', res.data.customerCarrierServiceCode);
        this.$set(this.formData, 'orgWarehouseId', res.data.orgWarehouseId);
        // 收货地址
        this.$set(this.formData, 'shipToAdress', res.data.shipToAddress1);
        this.$set(this.formData, 'shipToCountry', res.data.shipToCountry);
        this.$set(this.formData, 'shipToCity', res.data.shipToCity);
        this.$set(this.formData, 'shipToState', res.data.shipToState);
        this.$set(this.formData, 'carrierCode', res.data.carrierCode);
        this.$set(this.formData, 'shipToPostal', res.data.shipToPostal);
        this.$set(this.formData, 'transportationData', res.data.warehouseLastOutboundDate);


        // 投保商品table的重组
        res.data.deliverOrderItemEntityList.map((item, index) => {
          item.trackingNo = res.data.saleShipmentPackagesList.length > 0 ? res.data.saleShipmentPackagesList[0].trackNo : '';
          item.name = item.nameEn

        })
        this.datalist = res.data.deliverOrderItemEntityList
        this.datalist.map((item, index) => {
          this.getProductOne(item, index)
        })


      })
    },
    getProductOne (item, index) {
      HttpGetProductOne({
        id: item.productId
      }).then(res => {
        this.$set(this.datalist, index, { name: item.nameEn, erpsku: item.erpsku, weight: res.data.weight, trackingNo: item.trackingNo, productId: item.productId, qty: item.qty, packageType: res.data.materialType, isFragile: res.data.isFragile, oneAmount: Number(res.data.insuranceRate * item.qty) });
        if (index == this.datalist.length - 1) {
          let amount = this.datalist.reduce((pre, cur) => {
            pre = pre + cur.oneAmount;
            return pre
          }, 0)
          this.formData.totalAmount = amount;
          let num = Number(this.formData.totalAmount * (this.formData.insuranceProportion / 100))
          this.$set(this.formData, 'insuranceAmount', num.toFixed(4));
        }
      }, err => {
        this.$Message.error(err.message)
      })
    },
    remoteMethod1 (query) {

      this.loading1 = true;
      HttpVsSkuList({ page: 1, rows: 100, 'search[CN_erpSku]': query }).then(res => {
        this.loading1 = false;
        this.erpSkusList = res.data.content;
      });
    },
    getDetail () {
      HttpGetInsuranceOrderOne({
        insuranceOrderId: this.id
      }).then(res => {
        this.noOrderSource = res.data.sourceType == 1 ? true : false;
        this.formData = {
          insuranceAttachmentUrl: res.data.insuranceAttachmentUrl,
          insuranceStatus: res.data.insuranceStatus,
          policyNumber: res.data.policyNumber,
          sourceType: res.data.sourceType,
          sourceId: res.data.sourceId,
          sourceNo: res.data.sourceNo,
          platformNo: res.data.platformNo,
          insuranceServiceId: res.data.serviceRequest.id,
          remark: res.data.remark,

          transportationType: res.data.logisticsRequest.transportationType,
          carrierCode: res.data.logisticsRequest.carrierCode,
          orgWarehouseId: res.data.logisticsRequest.orgWarehouseId,
          shipFromCountry: res.data.logisticsRequest.shipFromCountry,
          shipFromState: res.data.logisticsRequest.shipFromState,
          shipFromCity: res.data.logisticsRequest.shipFromCity,
          shipFromAdress: res.data.logisticsRequest.shipFromAdress,
          shipToCountry: res.data.logisticsRequest.shipToCountry,
          shipToState: res.data.logisticsRequest.shipToState,
          shipToCity: res.data.logisticsRequest.shipToCity,
          shipToAdress: res.data.logisticsRequest.shipToAdress,
          insuranceCompletionTime: res.data.logisticsRequest.insuranceCompletionTime,
          transportationData: res.data.logisticsRequest.transportationData,
          shipFromPostal: res.data.logisticsRequest.shipFromPostal,
          shipToPostal: res.data.logisticsRequest.shipToPostal,

          insuranceType: res.data.rateRequest.insuranceType,
          totalAmount: res.data.rateRequest.totalAmount,
          insuranceAmount: res.data.rateRequest.insuranceAmount,
          insuranceProportion: res.data.rateRequest.insuranceProportion,
          insuranceFee: res.data.rateRequest.insuranceFee,

        }
        this.insuranceFeeCurrency = res.data.rateRequest.insuranceFeeCurrency;
        this.datalist = res.data.productRequestList
      }, err => {
        this.$Message.error({ content: err.message, duration: 10, closable: true });
      })
    },
    getTransType (val) {
      if (!val) return;
      HttpTransType({
        serviceId: val
      }).then(res => {
        let one = res.data.filter(item => {
          return item.carrierCode == this.formData.carrierCode
        })[0]
        this.$set(this.formData, 'transportationType', one.insuranceTransportType);
      }, err => {
        this.formData.transportationType = '';
        this.$Message.error(err.message);
      })
    },
    remove (index) {
      this.datalist.splice(index, 1);
      let amount = this.datalist.reduce((pre, cur) => {
        pre = pre + cur.oneAmount;
        return pre
      }, 0)
      this.formData.totalAmount = amount;
      let num = Number(this.formData.totalAmount * (this.formData.insuranceProportion / 100))
      this.$set(this.formData, 'insuranceAmount', num.toFixed(4));
    },
    getData () {

      let servecode = this.insuranceList.filter(item => { return item.value === this.formData.insuranceServiceId })[0]
      let data = {
        id: this.id,
        orgId: global.SYSID,
        insuranceOrgId: 1000030,
        policyNumber: this.formData.policyNumber || '',
        sourceType: !this.noOrderSource ? 0 : 1,
        sourceId: this.noOrderSource ? this.formData.sourceId : '',
        sourceNo: this.formData.sourceNo || '',
        platformNo: this.formData.platformNo,
        remark: this.formData.remark,
        serviceRequest: {
          id: this.formData.insuranceServiceId,
          code: servecode.label,
        },
        logisticsRequest: {
          transportationType: this.formData.transportationType,
          carrierCode: this.formData.carrierCode,
          orgWarehouseId: this.formData.orgWarehouseId,
          shipFromCountry: this.formData.shipFromCountry,
          shipFromState: this.formData.shipFromState,
          shipFromCity: this.formData.shipFromCity,
          shipFromAdress: this.formData.shipFromAdress,
          shipFromPostal: this.formData.shipFromPostal,

          shipToCountry: this.formData.shipToCountry,
          shipToState: this.formData.shipToState,
          shipToCity: this.formData.shipToCity,
          shipToAdress: this.formData.shipToAdress,
          shipToPostal: this.formData.shipToPostal,

          insuranceCompletionTime: this.formData.insuranceCompletionTime,
          transportationData: this.formData.transportationData,
        },
        productRequestList: this.datalist,
        rateRequest: {
          insuranceType: this.formData.insuranceType,
          totalAmount: this.formData.totalAmount,
          insuranceAmount: this.formData.insuranceAmount,
          insuranceProportion: this.formData.insuranceProportion,
          insuranceFee: this.formData.insuranceFee || '',
          totalAmountCurrency: 'USD'
        }

      }
      return data
    },
    async submit (type) {
      let bool1 = await this.$refs.editform1.validate()
      if (!bool1) return
      let bool2 = await this.$refs.editform2.validate()
      if (!bool2) return
      let bool3 = await this.$refs.editform3.validate()
      if (!bool3) return
      // 判断输入值的大小
      if (this.formData.insuranceProportion > 130 || this.formData.insuranceProportion < 100) {
        this.$Message.error('加成比例填写请在范围内！');
        return;
      }
      // 判断tracking是否填写
      let flag = false;
      if (this.formData.transportationType == 0) {
        this.datalist.map(item => {
          if (!item.trackingNo) {
            flag = true;
          }
        })
      }
      if (flag) {
        this.$Message.error('Tracking不能为空！');
        return;
      }
      // 判断总货值是否为0
      if (this.formData.totalAmount == 0 && this.noOrderSource) {
        this.$Message.error('总货值不能为0，请输入货值金额或到产品管理维护投保金额'); return;
      } else if (this.formData.totalAmount == 0 && !this.noOrderSource) {
        this.$Message.error('总货值不能为0，请到产品管理维护投保金额!'); return;
      }

      // 保存为草稿
      if (type == 'edit') {
        HttpSaveInsuranceOrder(this.getData()).then(res => {
          this.$Message.success(res.message);
          this.cancel();
        }, err => {
          this.$Message.error({ content: err.message, duration: 20, closable: true });
        })
      } else {
        HttpSubmitInsuranceOrder(this.getData()).then(res => {
          this.$Message.success(res.message);
          this.cancel();
        }, err => {
          this.$Message.error({ content: err.message, duration: 20, closable: true });
        })
      }
    },
    cancel () {
      this.$router.push({
        name: "insuranceList"
      })
    }
  }
}
</script>
